<template>
    <div>
        <Modal
                v-model="show_success"
                title="成交"
                :mask-closable="false"
                :closable="false"
                width="900"
        >
            <div class="ivu-modal-close" @click="closeWin">
                <i class="ivu-icon ivu-icon-ios-close"></i>
            </div>
            <Divider v-if="order_id">当前单号：{{order_id}} / 客户名称：{{customer_name}}</Divider>
            <Form :model="successSubmit" :rules="ruleValidate" inline :label-width="100" >
                <FormItem label="所属系统" prop="order_product_id">
                    <Select style="width:187px" placeholder="请选择系统" v-model="successSubmit.order_product_id " filterable multiple>
                        <Option v-for="item in product_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="客户来源" prop="customer_source_id">
                    <Select style="width:187px" placeholder="请选择客户来源" v-model="successSubmit.customer_source_id " filterable>
                        <Option v-for="item in source_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="成交时间" prop="pay_time">
                    <DatePicker style="width:187px"  type="datetime" v-model="successSubmit.pay_time" placeholder="选择成交时间" @on-change="changeSuccessDate"></DatePicker>
                </FormItem>

                <FormItem label="成交方式" prop="transaction_type_id">
                    <Select style="width:187px" placeholder="请选择成交方式" v-model="successSubmit.transaction_type_id" filterable >
                        <Option v-for="item in transaction_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                
                <FormItem label="完整单号" prop="order_number">
                    <Input  style="width:165px"   placeholder="请填写完整订单号" v-model="successSubmit.order_number"  >
                    </Input>
                </FormItem>
                <FormItem label="已收金额" prop="money">
                    <Input  placeholder="请填写已收金额"   v-model="successSubmit.money"  >
                    </Input>
                </FormItem>
                <FormItem label="尾款" prop="retainage">
                    <Input   placeholder="如没有，可以不填写" v-model="successSubmit.retainage"  >
                    </Input>
                </FormItem>
                <FormItem label="企微群" prop="qq_group">
                    <Input  placeholder="请填写所在群" type="text" v-model="successSubmit.qq_group" />
                </FormItem>
                <FormItem label="服务费" prop="servicecharge">
                    <Input  style="width:165px"   placeholder="请填写服务费" v-model="successSubmit.servicecharge"  >
                    </Input>
                    <Tooltip content="作为下次收款的依据">
                        <Icon style="margin-left:3px;cursor:pointer" size="20" type="ios-help-circle-outline" />
                    </Tooltip>
                </FormItem>
                <FormItem label="售后人员" prop="aftersale_id">
                    <Select  style="width:165px" placeholder="请选择售后人员"  v-model="successSubmit.aftersale_id" clearable  filterable >
                        <Option v-for="(item, index) in department_member_list" :value="item.id" :key="index">{{item.platform_name}}-{{ item.name }}</Option>
                    </Select>
                    <Tooltip >
                        <div slot="content">
                            <p>不选择售后则默认为不需要售后</p>
                            <p>订单将直接进入完结状态</p>
                        </div>
                        <Icon style="margin-left:3px;cursor:pointer" size="20" type="ios-help-circle-outline" />
                    </Tooltip>
                </FormItem>
                <span v-if="!successSubmit.aftersale_id">
                    <FormItem label="到期类型" prop="duesoon_type">
                        <Select style="width:187px" placeholder="请选择到期类型" v-model="successSubmit.duesoon_type" filterable >
                            <Option value="1" >选择到期时间</Option>
                            <Option value="2" >永久有效</Option>
                        </Select>
                    </FormItem>
                </span>
                <span v-if="!successSubmit.aftersale_id && successSubmit.duesoon_type == 1">
                    <FormItem label="到期时间" prop="servicecharge">
                        <DatePicker style="width:187px" type="date" placeholder="选择日期" @on-change="changeDate"></DatePicker>
                    </FormItem>
                </span>
                <FormItem label="服务要求" prop="service_requirements">
                    <Input style="width:460px"  placeholder="请填写服务要求：系统类型 公众认证情况 是否需要申请支付功能" type="textarea" v-model="successSubmit.service_requirements" />
                </FormItem>
                <FormItem label="续费" prop="is_two_sale">
                    <RadioGroup  v-model="successSubmit.is_two_sale">
                        <Radio  label="1">是</Radio>
                        <Radio label="0" >否</Radio>
                    </RadioGroup >
                </FormItem>
                <Divider>客户信息</Divider>
                <FormItem label="姓名" prop="name">
                    <Input  placeholder="请填写姓名" v-model="successSubmit.name"  >
                    </Input>
                </FormItem>
                <FormItem label="备注名称" prop="remark">
                    <Input  placeholder="请填写备注名称" v-model="successSubmit.remark"  >
                    </Input>
                </FormItem>
                <FormItem label="手机号" prop="phone">
                    <Input  placeholder="请填写手机号" v-model="successSubmit.phone"  >
                    </Input>
                </FormItem>
                <FormItem label="微信昵称" prop="wechat_number">
                    <Input  placeholder="请填写微信昵称" v-model="successSubmit.wechat_number"  >
                    </Input>
                </FormItem>
                <FormItem label="旺旺号" prop="wangwang_number">
                    <Input  placeholder="请填写旺旺号" v-model="successSubmit.wangwang_number"  >
                    </Input>
                </FormItem>
                <FormItem label="选择城市" prop="city_number">
                    <CitySelect @select_city="success_city" :default_citys="successSubmit.city_number"></CitySelect>
                </FormItem>
                <FormItem label="详细地址" prop="detailed_address">
                    <Input style="width: 360px;" placeholder="请填写详细地址" v-model="successSubmit.detailed_address"></Input>
                </FormItem>
                <Button v-if="successSubmit.detailed_address" type="primary" @click="show_latitude = true">选择经纬度</Button >
                <FormItem label="经纬度" prop="latlng">
                    <Input placeholder="经纬度" v-model="successSubmit.latlng" disabled></Input>
                </FormItem>
                <FormItem label="是否为大客户" prop="is_big">
                    <RadioGroup v-model="successSubmit.is_big">
                        <Radio label="1">是</Radio>
                        <Radio label="0" >否</Radio>
                    </RadioGroup >
                </FormItem>
            </Form>
            <div slot="footer">
                <Button  type="primary"  @click="success_order">确定</Button >
            </div>
        </Modal>

        <Modal
                v-model="show_latitude"
                title="选择经纬度"
                :mask-closable="false"
                width="700"
                @on-visible-change="handleModalVisibleChange"
        >
            <div>
                <div>请在地图上选择客户所在位置</div>
                <div v-if="isModalMounted">
                    <tencent-map :address="successSubmit.detailed_address" :zoom="13" @child-to-parent="handleChildData"/>
                    <!-- <baiduMap :address="submitInfo.detailed_address" :zoom="13" @child-to-parent="handleChildData"/> -->
                </div>
            </div>
            <div slot="footer">
                <Button  type="primary"  @click="submitLatitude">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import {get_transaction} from "@/api/customer"
    import {CitySelect} from "@/components/mainLayout"
    import {product_list, source_indexs} from "@/api/system"
    import moment from "moment"
    import TencentMap from "@/components/TencentMap/TencentMap.vue";
    import baiduMap from "@/components/baiduMap/baiduMap.vue";
    export default {
        components:{
            CitySelect,
            TencentMap,
            baiduMap,
        },
        props:{
            show_success:{
                type:Boolean,
                defaly:false
            },
            order_id:"",
            customer_name:"",
            department_member_list:{
                Array
            },
            successSubmit:{
                Object,
                default:function(){
                    return {};
                }
            },
        },
        data() {
            return {
                transaction_list:[],
                product_list:{},
                source_list:{},
                is_submit:0,
                options3: {
                    disabledDate (date) {
                        return date && date.valueOf() > Date.now();
                    }
                },
                ruleValidate:{
                    money: [
                        { required: true, message: '请填写已付金额', trigger: 'blur' }
                    ],
                    qq_group: [
                        { required: true, message: '请填写企微群号', trigger: 'blur' }
                    ],
                    name: [
                        { required: true, message: '请填写姓名', trigger: 'blur' }
                    ],
                    wechat_number: [
                        { required: true, message: '请填写微信号', trigger: 'blur' }
                    ],
                    servicecharge: [
                        { required: true, message: '请填写服务费', trigger: 'blur' }
                    ],
                    transaction_type_id: [
                        { required: true, message: '请填写成交方式', trigger: 'blur' }
                    ],
                    service_requirements: [
                        { required: true, message: '请填写服务要求', trigger: 'blur' }
                    ],
                    order_product_id: [
                        { required: true, message: '请填写产品类型', trigger: 'blur' }
                    ],
                    customer_source_id: [
                        { required: true, message: '请选择客户来源', trigger: 'blur' }
                    ],
                    order_number: [
                        { required: true, message: '请填写完整单号', trigger: 'blur' }
                    ],
                    is_two_sale: [
                        { required: true, message: '请选择续费类型', trigger: 'blur' }
                    ]
                },
                show_latitude: false,
                isModalMounted: false,
                latlngData: '',
            }
        },
        created () {
            this.get_product_list()
            this.get_transaction_list();
            this.get_source_indexs()
        },
        methods: {
            handleChildData(data) {
                this.latlngData = data.lat + ',' + data.lng;
            },
            handleModalVisibleChange(visible) {
                if (visible) {
                    this.$nextTick(() => {
                        this.isModalMounted = true;
                    });
                } else {
                    this.isModalMounted = false;
                }
            },
            submitLatitude() {
                this.successSubmit.latlng = this.latlngData;
                this.show_latitude = false;
            },
            closeWin(){
                this.$emit("update:show_success", false);
            },
            get_transaction_list(){
                get_transaction().then(res=>{
                    if(res.code == 200) {
                        this.transaction_list = res.data
                    }
                })
            },
            get_product_list(){
                product_list().then(res=>{
                    if(res.code == 200) {
                        this.product_list = res.data
                    }
                })
            },

            get_source_indexs(){
                source_indexs().then(res=>{
                    if(res.code == 200) {
                        this.source_list = res.data
                    }
                })
            },

            changeSuccessDate(e){
                this.successSubmit.pay_time = e;
            },
            success_city(e){
                this.successSubmit.city_name = e.city_name
                this.successSubmit.city_number = e.city_number
            },
            changeDate(e){
                this.successSubmit.expiration_date = e;
            },
            success_order(){
                if(this.is_submit == 1) {
                    return
                }
                this.is_submit = 1;
                // if ( this.successSubmit.order_product_id == "" || this.successSubmit.order_product_id == null) {
                //     this.$Message.error("请选择系统");return;
                // }
                if(this.successSubmit.money == "" || isNaN(this.successSubmit.money)) {
                    this.is_submit = 0;
                    this.$Message.error("请正确填写成交金额");return
                }
                
                if(this.successSubmit.servicecharge === "" || isNaN(this.successSubmit.servicecharge)) {
                    this.is_submit = 0;
                    this.$Message.error("请正确填写服务费");return
                }
                if ( this.successSubmit.pay_time == "" || this.successSubmit.pay_time == null) {
                    this.is_submit = 0;
                    this.$Message.error("请选择成交时间");return;
                }

                if(this.successSubmit.aftersale_id == "" && this.successSubmit.duesoon_type == '1' && this.successSubmit.expiration_date == "") {
                    this.is_submit = 0;
                this.$Message.error("售后人员或者到期时间必须选择一个");return
                }
                this.successSubmit.money = this.successSubmit.money == ""? 0 : this.successSubmit.money;
                if ( this.successSubmit.transaction_type_id == "" || this.successSubmit.transaction_type_id == null) {
                    this.is_submit = 0;
                    this.$Message.error("请选择成交方式");return;
                }
                
                if ( this.successSubmit.service_requirements == "" || this.successSubmit.service_requirements == null) {
                    this.is_submit = 0;
                    this.$Message.error("请填写服务要求");return;
                }
                
                if ( this.successSubmit.qq_group == "" || this.successSubmit.qq_group == null) {
                    this.is_submit = 0;
                    this.$Message.error("请填写所在的企微群");return;
                }
                if ( this.successSubmit.name == "" || this.successSubmit.name == null) {
                    this.is_submit = 0;
                    this.$Message.error("请填写客户姓名");return;
                }

                if ( this.successSubmit.wechat_number == "" || this.successSubmit.wechat_number == null) {
                    this.is_submit = 0;
                    this.$Message.error("请填写客户微信昵称");return;
                }

                // if ( this.successSubmit.order_number == "" || this.successSubmit.order_number == null) {
                //     this.is_submit = 0;
                //     this.$Message.error("请填写完整单号");return;
                // }
                
                this.successSubmit.pay_time = moment(this.successSubmit.pay_time).format('YYYY-MM-DD HH:mm:ss');
                this.$emit("submitSuccess");
                
            },
        }
    }
</script>

<style scoped>
>>>.ivu-modal .ivu-picker-panel-body-wrapper .ivu-picker-confirm  .ivu-btn-text{
    display:unset!important
}

</style>